module.exports = __webpack_public_path__ + "magnifier.svg?fc22ac60b6a486d80a5f6a69835e5776";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/magnifier.svg
// module id = 22
// module chunks = 0